import * as yup from 'yup';

export const commonCompanyValidation: { [x: string]: any; } = {
    companyCode: yup.string().required("Missing."),
    companyType: yup.string().required("Missing."),
    countryCode: yup.string().required("Missing."),
    signOnDate: yup.date().required("Missing."),
    activeInd: yup.string().required("Missing."),
    mobileNo: yup.string().required("Missing."),
    contactPerson: yup.string().required("Missing."),
    emailAddress: yup.string().required("Missing."),
    customerType: yup.string().required("Missing."),
};
export const masterCompanyValidation: { [x: string]: any; } = {
    companyCode: yup.string().required("Missing."),
    companyType: yup.string().required("Missing."),
    countryCode: yup.string().required("Missing."),
    signOnDate: yup.date().required("Missing."),
    activeInd: yup.string().required("Missing."),
};
export const allianceCompanyValidation: { [x: string]: any; } = {
    companyCode: yup.string().required("Missing."),
    activeInd: yup.string().required("Missing."),
};

export const commonCompanyValidationSchema = yup.object().shape(commonCompanyValidation);
export const masterCompanyValidationSchema = yup.object().shape(masterCompanyValidation);
export const allianceCompanyValidationSchema = yup.object().shape(allianceCompanyValidation);
